import Axios from "axios"
import Qs from "qs"
import Md5 from 'js-md5';
import { Toast } from 'mint-ui';


//接口密钥为
var screte="mVSGKrLIRMwcGtHH";

//参数“接口签名”的构建方式：MD5(传输密钥 +yyyyMMdd).upper()。
var dateStr=getNowDate();
var apiSign=Md5(screte+dateStr).toUpperCase();

//设置post请求头
Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

//设置基址
Axios.defaults.baseURL='http://togzs.gzhcxt.com';

//请求拦截器
Axios.interceptors.request.use(
    config=>{
        var openid = window.localStorage.getItem("openid");
  //判断请求的类型：如果是post请求就把默认参数拼到data里面；如果是get请求就拼到params里面
  //判断本地缓存是否存在openid,是则已表示登录过，需要将openid添加再参数中，无则不需要添加，需要重新获取openid
  if(config.method==='post'){
      if(openid!=null && openid!=""){
        config.data={
            "接口签名":apiSign,
            "h5OpenId":openid,
            ...config.data
          }
      }else{
        config.data={
            "接口签名":apiSign,
            ...config.data
          }
      }
  }else if(config.method==='get'){
    config.params={
      ...config.params
    }
  }
  return config;
    },function(error){
        return Promise.reject(error);
    }
      
);

// 响应拦截器
Axios.interceptors.response.use(    
    response => {   
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        if (response.data.statusCode === 200) {
            return Promise.resolve(response);        
        } else {            
            Toast(response.data.errors);
        }    
    },    
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {     
        // if (error.response.status) {            
        //     switch (error.response.status) {                
        //         // 401: 未登录
        //         // 未登录则跳转登录页面，并携带当前页面的路径
        //         // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        //         case 401:                    
        //             router.replace({                        
        //                 path: '/login',                        
        //                 query: { 
        //                     redirect: router.currentRoute.fullPath 
        //                 }
        //             });
        //             break;
 
        //         // 403 token过期
        //         // 登录过期对用户进行提示
        //         // 清除本地token和清空vuex中token对象
        //         // 跳转登录页面                
        //         case 403:
        //              Toast({
        //                 message: '登录过期，请重新登录',
        //                 duration: 1000,
        //                 forbidClick: true
        //             });
        //             // 清除token
        //             localStorage.removeItem('token');
        //             store.commit('loginSuccess', null);
        //             // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
        //             setTimeout(() => {                        
        //                 router.replace({                            
        //                     path: '/login',                            
        //                     query: { 
        //                         redirect: router.currentRoute.fullPath 
        //                     }                        
        //                 });                    
        //             }, 1000);                    
        //             break; 
 
        //         // 404请求不存在
        //         case 404:
        //             Toast({
        //                 message: '网络请求不存在',
        //                 duration: 1500,
        //                 forbidClick: true
        //             });
        //             break;
        //         // 其他错误，直接抛出错误提示
        //         default:
        //             Toast({
        //                 message: error.response.data.message,
        //                 duration: 1500,
        //                 forbidClick: true
        //             });
        //     }
        //     return Promise.reject(error.response);
        // }
    }    
);

//封装get、post方法
export function axiosGet(url,params){
    return new Promise((resolve,reject)=>{
        Axios.get(url,{params:params}).then(res=>{
            resolve(res.data);
        }).catch(err=>{
            reject(err.data);
        })
    }); 
}

export function axiosPost(url,params){
    return new Promise((resolve,reject)=>{
        Axios.post(url, params).then(res=>{
            resolve(res.data);
        }).catch(err=>{
            reject(err.data);
        })
    }); 
}

//获取当前年月日
function getNowDate() {
    let date = new Date();
    let y = date.getFullYear().toString();
    let m = (date.getMonth() + 1).toString();
    let d = date.getDate().toString();
          m = m < 10 ? "0" + m : m;
          d = d < 10 ? "0" + d : d;
          return y + m + d ;
}





// WEBPACK FOOTER //
// ./src/request/axios.js